import Slider from '../Slider';
import PosterReel from './PosterReel';

import styles from './reels.module.scss';

const ReelsSkeleton = (props) => {
    const { titol, skeletonItems = 4 } = props;

    return (
        <div className={styles.contReel}>
            <Slider format='poster-reel' titol={titol}>
                {Array.from({ length: skeletonItems }, (_, index) => (
                    <PosterReel key={`poster-reel-skeleton-${index}`} isLoading={true} />
                ))}
            </Slider>
        </div>
    );
};

export default ReelsSkeleton;
